import  React from 'react';
import _ from 'underscore';

// Opens entire page covering modal. Used for confirmations.
export const ConfirmationModal = ({title, description, confirmText, cancelText, onConfirm, onCancel, onClose, visible}) => {
  return(
    <div
      className="confirmation-modal"
      style={ {display: (visible ? "flex" : "none")} }
      onClick={ onClose }
    >
      <div className="modal-content">
        <h1 className="title">
          {title}
        </h1>
        <div className="buttons">
          <button 
            id="cancelBtn" 
            className="standard-btn light-blue inline"
            onClick={ onCancel }>
              {cancelText}
          </button>
          <button 
            id="confirmBtn" 
            className="standard-btn green inline"
            onClick={ onConfirm }>
              {confirmText}
          </button>  
        </div>  
      </div>
    </div>
  );
};

